import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3374">
      <Navbar data-id="element-3375" />
      <main data-id="element-3376">
        <ConsularAffairs data-id="element-3377" />
      </main>
      <Footer data-id="element-3378" />
      <FeedbackPopup data-id="element-3379" />
    </div>;
}